import { dataAccessScope } from "src/configs/subscription-access";
import { datalakeApi } from "src/api/datalake";
import { slice as sliceD } from "src/slices/datalake";
import { store } from "src/store";
import { slice as sliceT } from "src/slices/datatype";

// Share completion with every chart waiting on the same key, including failures.
const loading = new Map();
let typesPromise = null;

const getData = (requests, scope = dataAccessScope(), aptId = new URLSearchParams(window.location.search).get("id")) => async (dispatch) => {
  const state = store.getState().datalake.__scopes?.[scope] || {};
  const missing = new Map(requests.filter(Boolean)
    .filter((request) => !(request.getKey() in state))
    .map((request) => [request.getKey(), request]));
  const waiting = new Set();
  const can = [];
  for (const [key, request] of missing) {
    if (loading.has(`${scope}:${key}`)) waiting.add(loading.get(`${scope}:${key}`));
    else can.push(request);
  }
  if (can.length) {
    const pending = Promise.resolve().then(() => datalakeApi.getData(can, scope.split(":")[1], aptId))
      .then((res) => {
        if (scope.split(":")[0] === dataAccessScope().split(":")[0]) {
          dispatch(sliceD.actions.getScopedDataLakes({ scope, responses: res }));
        }
        return null;
      })
      .catch((error) => {
        console.error("fail to get data:", error.message);
        return error;
      })
      .finally(() => {
        for (const request of can) loading.delete(`${scope}:${request.getKey()}`);
      });
    for (const request of can) loading.set(`${scope}:${request.getKey()}`, pending);
    waiting.add(pending);
  }
  const results = await Promise.all(waiting);
  return results.find(Boolean) || null;
};

const getTypes = () => async (dispatch) => {
  const { typesInit } = store.getState().datatype;
  if (typesInit) return;
  if (!typesPromise) {
    typesPromise = datalakeApi
      .getTypes()
      .then((types) => dispatch(sliceT.actions.getTypes(types)))
      .finally(() => {
        typesPromise = null;
      });
  }
  return typesPromise;
};

export const thunks = {
  getData,
  getTypes,
};
